import { motion } from "framer-motion";
import { PhotoPlaceholder } from "./PhotoPlaceholder";
import { Plus } from "lucide-react";
import { formatPrice } from "../../data/siteData";

export const DishCard = ({ dish, index = 0, onAdd }) => (
  <motion.article
    data-testid={`dish-card-${dish.id}`}
    initial={{ opacity: 0, y: 28 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.1 }}
    transition={{ duration: 0.7, delay: (index % 4) * 0.07, ease: [0.16, 1, 0.3, 1] }}
    className="dish-card group flex flex-col h-full rounded-2xl overflow-hidden bg-[#123322] border border-[#D4A359]/15 hover:border-[#D4A359]/45 transition-[border-color,transform,box-shadow] duration-500 hover:-translate-y-1.5 hover:shadow-[0_30px_60px_-30px_rgba(0,0,0,0.7)]"
  >
    <PhotoPlaceholder src={dish.image} alt={dish.name} label="Photo du plat" className="aspect-[4/3] border-b border-[#D4A359]/15" />
    <div className="flex flex-1 flex-col p-5 sm:p-6">
      <div className="flex items-start justify-between gap-4">
        <h3 className="font-display text-xl leading-snug text-[#F7F4EB]" data-testid={`dish-name-${dish.id}`}>{dish.name}</h3>
        {dish.price != null && (
          <span className="shrink-0 rounded-full border border-[#D4A359]/40 bg-[#D4A359]/10 px-3 py-1 text-base font-semibold text-[#E5B66C]" data-testid={`dish-price-${dish.id}`}>
            {formatPrice(dish.price)}
          </span>
        )}
      </div>
      {dish.ingredients && (
        <p className="mt-3 text-sm leading-relaxed text-[#D6CFC0]" data-testid={`dish-ingredients-${dish.id}`}>{dish.ingredients}</p>
      )}
      {onAdd && dish.price != null && (
        <button type="button" onClick={() => onAdd(dish)} className="btn-ghost mt-auto !mt-6 !py-2.5 text-sm self-start" data-testid={`dish-add-${dish.id}`}>
          <Plus className="w-4 h-4" /> Ajouter au panier
        </button>
      )}
    </div>
  </motion.article>
);

export const DishGrid = ({ items, onAdd }) => (
  <div className="grid gap-5 sm:gap-6 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
    {items.map((d, i) => (
      <DishCard key={d.id} dish={d} index={i} onAdd={onAdd} />
    ))}
  </div>
);
